import api from './api';

export const getUsers = (currentPage, PageSize, config) => {
    let errors = [];
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Users/GetAll?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}

export const disableUsers = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Users/DisableAccount/${value}`, {}, config);
    }
}

export const enableUsers = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Users/EnableAccount/${value}`, {}, config);
    }
}
